import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section data-testid="notfound-page" className="mx-auto max-w-[1500px] px-6 md:px-10 lg:px-14 min-h-[80svh] flex flex-col justify-center">
      <div className="eyebrow mb-6">404</div>
      <h1 className="display text-ink" style={{ fontSize: "clamp(56px, 12vw, 200px)" }}>
        Page not found.
      </h1>
      <p className="mt-8 text-ink-800 text-lg max-w-lg">
        The page you&rsquo;re looking for has either moved or doesn&rsquo;t exist.
      </p>
      <Link to="/" data-testid="notfound-home"
        className="mt-10 inline-flex items-center gap-3 bg-ink text-paper px-6 py-3 text-sm font-medium hover:bg-ink-800 w-fit">
        Return to index →
      </Link>
    </section>
  );
}
